import { useEffect, useState } from 'react'
import { useAuth } from '../lib/AuthContext'
import { supabase } from '../lib/supabase'
import { useTrackPresence } from '../lib/presence'
import AvisoPerfilIncompleto from './AvisoPerfilIncompleto'
import LegalPill from './LegalPill'
import CarritoFlotante from './CarritoFlotante'
import ScrollHint from './ScrollHint'
import { TopNavCliente, BottomNavCliente } from './tienda-v5'

const RESPONSABLE_LABEL = {
  gimena:  'Gimena',
  nico:    'Nico',
  roberto: 'Roberto',
  otro:    'tu contacto Limpack',
}

// FIX D (decisión Nico: "look v5, rutas cliente"): el shell del panel se ve idéntico a la tienda
// pública (mismo TopNav dark + BottomNav mobile v5) PERO los items del nav son las secciones del
// panel, no las públicas. El nav vive ahora en <TopNavCliente/> + <BottomNavCliente/> (self-contained:
// auth, logout, active state y drawer adentro). Este layout queda como shell fino: solo compone el
// nav + los avisos globales + el contenido de las 15 páginas (intacto).
export default function ClienteLayout({ children, title }) {
  const { user, profile } = useAuth()
  const [fueraZonaInfo, setFueraZonaInfo] = useState(null)  // { responsable } o null

  // Live presence: marca al cliente logueado como online en el canal de clientes
  // 2026-06-12: solo si el rol es cliente o portero (admin/superadmin/marketing/repartidor NO se cuentan)
  const esClienteReal = user?.id && (!profile?.role || profile.role === 'cliente' || profile.role === 'portero')
  useTrackPresence(esClienteReal ? 'presence:cliente' : null, { user_id: user?.id, role: profile?.role })

  useEffect(() => {
    if (!user?.id) { setFueraZonaInfo(null); return }
    supabase
      .from('clientes')
      .select('fuera_zona, entrega_responsable')
      .or(`titular_id.eq.${user.id},beneficiario_id.eq.${user.id}`)
      .eq('fuera_zona', true)
      .limit(1)
      .maybeSingle()
      .then(({ data }) => {
        if (data?.fuera_zona) setFueraZonaInfo({ responsable: data.entrega_responsable })
      })
  }, [user?.id])

  return (
    <div className="cl-shell">
      {/* ───── Nav v5 (rutas cliente) — self-contained ───── */}
      <TopNavCliente />

      {/* Aviso global: perfil incompleto (sticky arriba) */}
      <AvisoPerfilIncompleto />

      {/* Pill legal: aparece 1 vez por usuario, link a Privacidad y T&C */}
      <LegalPill />

      {/* ───── Main ───── */}
      <main className="cl-main">
        {title && <div className="cl-page-title">{title}</div>}
        {fueraZonaInfo && (
          <div className="cl-fz-banner">
            <span className="cl-fz-icon">🚫</span>
            <div className="cl-fz-text">
              <strong>Tu zona no está en cobertura.</strong> Tu entrega la coordina{' '}
              <strong>{RESPONSABLE_LABEL[fueraZonaInfo.responsable] || 'tu contacto Limpack'}</strong>{' '}
              · sin costo de envío. Cualquier consulta, escribinos por WhatsApp.
            </div>
          </div>
        )}
        {children}
      </main>

      {/* Carrito activo flotante (todas las páginas excepto Tienda) */}
      <CarritoFlotante />

      {/* Hint "hay más abajo" en pantallas con scroll */}
      <ScrollHint />

      {/* ───── Bottom nav v5 (mobile, rutas cliente) ───── */}
      <BottomNavCliente />

      <style>{`
        /* Portal cliente — shell dark (los navs traen su propio CSS). Tokens del tema landing. */
        :root {
          --cl-navy: #1A3461;
          --cl-teal: #00d4e0;
          --cl-bg: #070b14;
          --cl-card: rgba(255,255,255,.06);
          --cl-line: rgba(255,255,255,.08);
          --cl-text: #f1f5f9;
          --cl-muted: #8494a7;
          --cl-green: #16a34a;
        }
        .cl-shell {
          min-height: 100vh; background: var(--cl-bg);
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, "SF Pro Display", system-ui, sans-serif;
          color: var(--cl-text);
        }

        /* ───── Main ───── */
        .cl-main { padding-bottom: 90px; }
        @media (min-width: 900px) { .cl-main { padding-bottom: 0; } }
        .cl-page-title { display: none; }
        @media (min-width: 900px) { .cl-page-title { display: block; max-width: 1200px; margin: 20px auto 0; padding: 0 20px;
          font-size: 13px; font-weight: 700; color: var(--cl-muted); text-transform: uppercase; letter-spacing: .06em; } }

        /* Banner fuera de zona */
        .cl-fz-banner {
          margin: 12px 12px 0; padding: 12px 14px;
          background: rgba(251,191,36,.10); border: 1px solid rgba(251,191,36,.25); border-radius: 12px;
          display: flex; align-items: flex-start; gap: 10px; font-size: 13px; color: #fde68a; line-height: 1.4;
        }
        @media (min-width: 900px) { .cl-fz-banner { max-width: 1200px; margin: 12px auto 0; } }
        .cl-fz-icon { font-size: 18px; flex-shrink: 0; line-height: 1.2; }
        .cl-fz-text { flex: 1; }
        .cl-fz-text strong { color: #fef3c7; }
      `}</style>
    </div>
  )
}
